import React, {forwardRef, useCallback, useRef} from 'react'


import ProjectCollectionView
    from "../../../../../../core/manager/project-collection/project-collection-views/project-collection-view"
import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import ProjectCollectionView_MoreMenu from "./more-popover/more-menu"
import {addClass, removeClass} from "../../../../../../core/gd/utils/dom-and-react/react-utils"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"
import {FEATURE_WORKLOAD} from "../../../../../../core/gd/access-control/feature-access/const"

type Props = {
    className?              : string
    style?                  : any

    projectCollectionView   : ProjectCollectionView

    dndPreview?             : boolean
    dndHover?               : boolean
    dndIsDragged?           : boolean
    isMouseEntered?         : boolean
    dndIsDragInProgress?    : boolean
}

const SubmenuItem = forwardRef((props: Props, ref: any) => {

    const showMore = props.projectCollectionView.hasMoreMenu /*&& !props.isReadOnly*/

    const onTogglePopover = (value: boolean) => {
        if (value) {
            addClass(ref.current, 'with-more-popover')
        } else {
            removeClass(ref.current, 'with-more-popover')
        }
    }

    const onMenuItemClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (props.projectCollectionView.isPro /*props.projectCollectionView.acl.requiresUpgrade*/) {
            let feature = null
            // this is a patch
            if (props.projectCollectionView.systemType === ViewType.PROJECT_WORKLOAD) {
                feature = FEATURE_WORKLOAD
            }
            // end patch

            gd.modals.other.upgradeToPro(feature)
        } else {
            props.projectCollectionView.open()
        }
    }

    const showContextMenu = useCallback((e: React.MouseEvent) => {
        if (!showMore) return

        const menuParams = {
            view: props.projectCollectionView
        }

        gd.layout.contextMenu.show(e,
            <ProjectCollectionView_MoreMenu className     = "popover-project-view"
                                            menuParams    = {menuParams}
                                            hidePopover   = {() => gd.layout.contextMenu.hide()}/>,
            {
                component   : ref.current,
            }
        )
    }, [])

    const classes = Classes('item', props.className, {
        'dnd-preview'       : props.dndPreview,
        'dnd-is-dragged'    : props.dndIsDragged,
        'selected'          : props.projectCollectionView.id === gd.projectCollectionViews.currentView?.id,
        'with-more'         : props.projectCollectionView.hasMoreMenu
    })

    return (
        <div ref            = {ref}
             className      = {classes}
             style          = {props.style}
             onClick        = {onMenuItemClick}
             onContextMenu  = {showContextMenu}>
            <div className="label max-w-200" title={props.projectCollectionView.name}>
                {props.projectCollectionView.name}
            </div>

            {props.projectCollectionView.hasMoreMenu &&
                <PopupMenuButton className          = "ui5-ico-more s18"
                                 popoverClass       = "popover-project-view"
                                 menuComponent      = {ProjectCollectionView_MoreMenu}
                                 onTogglePopover    = {onTogglePopover}
                                 menuParams         = {{
                                     view: props.projectCollectionView
                                 }}/>}
        </div>
    )
})

export default SubmenuItem